import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Clients from './pages/Clients';
import Compliance from './pages/Compliance';
import Timesheets from './pages/Timesheets';
import Payroll from './pages/Payroll';
import DataImport from './pages/DataImport';
import Users from './pages/Users';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

// Staff pages (full access + read only): clients get bounced to their attendance portal
function AdminRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return user.role === 'client' ? <Navigate to="/timesheets" replace /> : children;
}

// Full-access only (user management, data import). Read-only users go home.
function FullAccessRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'client') return <Navigate to="/timesheets" replace />;
  return user.role === 'admin' ? children : <Navigate to="/" replace />;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<AdminRoute><Dashboard /></AdminRoute>} />
            <Route path="employees" element={<AdminRoute><Employees /></AdminRoute>} />
            <Route path="clients" element={<AdminRoute><Clients /></AdminRoute>} />
            <Route path="compliance" element={<AdminRoute><Compliance /></AdminRoute>} />
            <Route path="timesheets" element={<Timesheets />} />
            <Route path="payroll" element={<AdminRoute><Payroll /></AdminRoute>} />
            <Route path="import" element={<FullAccessRoute><DataImport /></FullAccessRoute>} />
            <Route path="users" element={<FullAccessRoute><Users /></FullAccessRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}